import { strIsNullOrEmpty, tryParseJSONObject } from '@fox/atoms/utils/string';
import { QuestionBlockMetadata } from '../../question-block/contracts';
import { QuestionValidator } from '../util/allow-next';

export const dataTableRequirementsValidator: QuestionValidator = (answer, metadataJson) => {
	if (!answer) return false;
	// const parsedAnswer = tryParseJSONObject<DataTableRowAnswer[]>(answer?.answer?.answerJson, []);
	const parsedAnswer = tryParseJSONObject<any[]>(answer?.answer?.answerJson, []);
	//datatable row answer will be in the runtime datatable
	const fieldMeta = tryParseJSONObject<QuestionBlockMetadata>(metadataJson, {});
	//const columns: IRenderDataTableQuestionProps['columns'] = fieldMeta?.columns ?? [];
	const columns: any['columns'] = fieldMeta?.columns ?? [];
	//IRenderDataTableQuestionProps will also be in runtime data table
	const requiredCols = columns.filter(c => c.required);
	return parsedAnswer.every(a => {
		return requiredCols.every(c => {
			return !strIsNullOrEmpty(a?.[c.id]);
		});
	});
};
